// Sprachweg der Kunden-Apps. reference: [1]
const FALLBACK = 'de';

const LOCALES = {
    de: 'de-DE',
    pl: 'pl-PL',
    en: 'en-GB',
};

export function getLang() {
    const fromWindow = typeof window !== 'undefined' ? window.m7Lang : undefined;
    if (typeof fromWindow === 'string' && fromWindow !== '') {
        return fromWindow.slice(0, 2).toLowerCase();
    }
    const fromHtml = typeof document !== 'undefined' ? document.documentElement?.lang : undefined;
    if (typeof fromHtml === 'string' && fromHtml !== '') {
        return fromHtml.slice(0, 2).toLowerCase();
    }
    return FALLBACK;
}

export function getLocale(lang = getLang()) {
    return LOCALES[lang] ?? LOCALES[FALLBACK];
}

export function createT(dictionaries, options = {}) {
    const warned = new Set();
    const langOf = options.lang ?? getLang;

    return function t(ident, params) {
        const lang = typeof langOf === 'function' ? langOf() : langOf;
        let text = dictionaries[lang]?.[ident];
        if (typeof text !== 'string' || text === '') {
            text = dictionaries[FALLBACK]?.[ident];
        }
        if (typeof text !== 'string' || text === '') {
            if (options.warn && !warned.has(ident)) {
                warned.add(ident);
                console.warn(`[i18n] Kein Text für '${ident}' (${lang})`);
            }
            text = ident;
        }
        if (params) {
            text = text.replace(/\{(\w+)\}/g, (match, name) => (name in params ? String(params[name]) : match));
        }
        return text;
    };
}

// reference: [2]
export function plural(n, forms, lang = getLang()) {
    const kategorie = new Intl.PluralRules(getLocale(lang)).select(Number(n));
    return forms[kategorie] ?? forms.other;
}

// reference: [3]
export function teile(text) {
    return String(text).split(/(\{\w+\})/).filter((stueck) => stueck !== '').map((stueck) => {
        const treffer = /^\{(\w+)\}$/.exec(stueck);
        return treffer ? {platzhalter: treffer[1]} : {text: stueck};
    });
}
